import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { TurnResource, turnsEnable } from '~/generated';
import { extractData } from '~/utils/query-utils';

type Variables = {
  enable: string;
  turnId: number;
};

export const useTurnEnable = (
  options: UseMutationOptions<TurnResource, unknown, Variables, unknown>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: Variables) =>
      extractData(
        turnsEnable({
          path: { id: variables.turnId },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          body: variables.enable as any as boolean,
        })
      ),
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({ queryKey: ['turns', variables.turnId] });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
